import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { AppTheme } from '../../../../theme/App.theme';
import './InfoCard.css';

const InfoCard = ({ 
  title, 
  value, 
  icon, 
  timingColor = AppTheme.PRIMARY_COLOR,
  titleColor = AppTheme.PRIMARY_BLACK,
  className = "",
  style = {},
  variant = "default" // "default", "timing", "epoch"
}) => {
  const getCardStyle = () => {
    const baseStyle = {
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
    };

    if (variant === 'auspicious') {
      return {
        ...baseStyle,
        backgroundColor: '#EFF6FF',
      };
    }

    if (variant === 'inauspicious') {
      return {
        ...baseStyle,
        backgroundColor: AppTheme.PRIMARY_LIGHT,
      };
    }

    if (variant === 'celestial') {
      return {
        ...baseStyle,
        backgroundColor: '#EFF6FF',
      };
    }

    if (variant === 'epoch') {
      return {
        ...baseStyle,
        backgroundColor: '#EBEFF9',
      };
    }

    return {
      ...baseStyle,
      minHeight: '100px',
    };
  };

  if(variant === 'celestial') {
    return (
      <Card
        className={`info-card ${className} ${variant}`}
        sx={getCardStyle()}
        style={style}
      >
        <CardContent
          className="pb-0"
          sx={{
            padding: "12px",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            gap: "12px",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          {/* Icon */}
          {icon && (
            <img
              src={icon}
              alt="Celestial Icon"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain"
              }}
            />
          )}

          <div className='d-grid'>
            {/* Title */}
            <Typography
              variant="body2"
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: titleColor,
              }}
            >
              {title}
            </Typography>

            {/* Value */}
            <Typography
              variant="h6"
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                color: timingColor,
                wordBreak: "break-word",
              }}
            >
              {value}
            </Typography>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card 
      className={`info-card ${className} ${variant}`}
      sx={getCardStyle()}
      style={style}
    >
      <CardContent 
        className='pb-0'
        sx={{ 
          padding: "12px",
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        {/* Icon */}
        {icon && (
          <Box
            sx={{
              fontSize: { xs: '24px', sm: '28px', md: '32px' },
              marginBottom: { xs: '8px', sm: '12px' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {icon}
          </Box>
        )}

        {/* Title */}
        <Typography
          variant="body2"
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            color: titleColor,
            marginBottom: '4px',
          }}
        >
          {title}
        </Typography>

        {/* Value */}
        <Typography
          variant="h6"
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            color: timingColor,
            wordBreak: 'break-word'
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
